import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import moment from '../../lib/moment.js'
import get from 'lodash/get'
import find from 'lodash/find'
import { FONTS, COLORS } from '../../constants'
import SearchBarConsentLogs from '../searchbar-consent-logs'
import { searchConsentLogs } from '../../function'

export default class ConsentLogsTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
      searchConsentLog: '',
      rowID: '',
      defaultConsentLogs: [],
      consentLogs: [],
      selectedStatus: '',
    }
    this.handleClickRow = this.handleClickRow.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleInputStatus = this.handleInputStatus.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    let list = []
    if (get(nextProps, 'data') && this.state.searchConsentLog === '') {
      for (let index = 0; index < this.props.data.length; index++) {
        const emp_id = get(find(this.props.employeeList, { _id: get(this.props.data[index], 'emp_code')}), 'emp_code')
        const firstName = get(find(this.props.employeeList, { _id: get(this.props.data[index], 'emp_code')}), 'first_name')
        const lastName = get(find(this.props.employeeList, { _id: get(this.props.data[index], 'emp_code')}), 'last_name')
        const empType = get(find(this.props.employeeList, { _id: get(this.props.data[index], 'emp_code')}), 'employee_type')
        const lob = get(find(this.props.masterData.masterData.lobs, { _id: get(find(this.props.employeeList, { _id: get(this.props.data[index], 'emp_code')}), 'lob_id')}), 'name')
        const status = get(this.props.data[index], 'status')
        const date = get(this.props.data[index], 'updated') ? moment(get(this.props.data[index], 'updated')).format('HH:mm - DD/MM/YYYY') : '-'
        list.push({
          emp_code: emp_id,
          first_name: firstName,
          last_name: lastName,
          employee_type: empType,
          lob: lob,
          status: status,
          updated: date,
        })
      }
      this.setState({
      consentLogs: list,
      defaultConsentLogs: list,
     })
    }
  }
  
  handleClickRow(e, edit_id, id) {
    this.props.handleClickEdit(id)
    this.setState({ id: edit_id })
  }

  checkTable(table, d) {
    if (table === 1) return d.company_code
    else if (table === 2) return d.department_code
    else if (table === 3) return d.division_code
    else if (table === 4) return d.emp_code
    else if (table === 5) return d.level_code
    else if (table === 6) return d.lob_code
    else if (table === 7) return d.position_code
    else if (table === 8) return d.team_code
  }
  handleClickSearch() {
    this.setState({ consentLogs: get(this.state, 'defaultConsentLogs').filter(searchConsentLogs, this.state.searchConsentLog) })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.filterSearchConsentLogs(this.state.selectedStatus)
    else if (e.target.value === '') this.setState({ employees: get(this.state, 'data'), searchConsentLog: '' })
    else this.setState({ searchConsentLog: e.target.value })
  }
  filterSearchConsentLogs(status) {
    let users =  get(this.state, 'defaultConsentLogs')
    //const search_status = this.state.selectedStatus
    if(status !== ''){
      users = users.filter((user) => {
        return user.status.includes(status)
      })
    }
    const search = this.state.searchConsentLog.toLowerCase()
    if (search !== '') {
      users = users.filter((user) => {
        return user.first_name.includes(search.toLowerCase())
        || user.last_name.includes(search.toLowerCase())
        || user.emp_code.includes(search)
      })
    }
    this.setState({ consentLogs: users})
  }
  handleInputStatus(data) {
    if (data.target.value !== '') {
      this.setState({ selectedStatus: data.target.value })
    } else {
      this.setState({ selectedStatus: '' })
    }
   this.filterSearchConsentLogs(data.target.value)
  }
  render() {
    
    
    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <SearchBarConsentLogs
          handleSearch={ this.handleSearch }
          handleInputStatus= { this.handleInputStatus }
        >
        </SearchBarConsentLogs>
        <NewTable bordered hover>
          <Header>
            <tr>
              {
                get(this.props, 'header.length') !== 0 &&
              get(this.props, 'header').map((h, key) =>
                <HeadTable>{ h }</HeadTable>
              )}
            </tr>
          </Header>
          <tbody style={ { width: '100%', display: 'block', maxHeight: 'calc(100vh - 200px)', overflowY: 'scroll' } }>
            {
              this.state.consentLogs.length !== 0 &&
              this.state.consentLogs.map((d, key) =>

            (<tr style={ { hover: '#E5E5E5', background: (key === this.state.id && get(this.props, 'span')) ? '#E5E5E5' : '' } }>
              <td>{ get(d, 'emp_code') + ' - '}
                  { get(d, 'first_name') + ' ' }
                  { get(d, 'last_name')}
              </td>
              <td>{ get(d, 'employee_type') }</td>
              <td>{ get(d, 'lob') }</td>
              <td>{ get(find(this.props.consent, { _id: this.props.document_code}), 'title') }</td>
              <td>{ get(d, 'status') }</td>
              <td>{ get(d, 'updated') }</td>
            </tr>)
          )}
          </tbody>
        </NewTable>
      </Wrapper>
    )
  }
}

ConsentLogsTable.propTypes = {
  handleClickEdit: PropTypes.func.isRequired,
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const NewTable = styled(Table)`
  background: white;
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  } 
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`



// WEBPACK FOOTER //
// ./src/components/table-consent-logs/index.js